import { Typography } from "../../atoms/typography";
import { cn, platformProps } from "../../lib";
import { useChatBubbleContext } from "./chat-bubble-context";
import { chatBubbleContentColor } from "./lib";
import type { ChatBubbleContentProps } from "./types";

export const ChatBubbleContent = ({ children, className, testID }: ChatBubbleContentProps) => {
  const { variant } = useChatBubbleContext();

  return (
    <Typography
      variant={variant === "system" ? "body-sm" : "body-md"}
      color={chatBubbleContentColor[variant]}
      // A system message's lines centre on native too, where the bubble's
      // text-center doesn't reach its text
      align={variant === "system" ? "center" : undefined}
      // A message keeps its line breaks, and a long word or link wraps inside
      // the bubble. Native text already does both, so these only change web
      whiteSpace="pre-wrap"
      // A message can be long-pressed to select and copy on native too, where
      // text isn't selectable by default
      selectable
      className={cn("web:break-words", className)}
      {...platformProps({ testID, slot: "chat-bubble-content" })}
    >
      {children}
    </Typography>
  );
};

ChatBubbleContent.displayName = "ChatBubble.Content";
